import React, { useState, useEffect, useCallback } from 'react';
import s from './NavMenu.module.css';

const NAV_LINKS = [
  { label: 'אודות הסטודיו', target: 'about' },
  { label: 'הגישה שלנו', target: 'approach' },
  { label: 'שירותים', target: 'services' },
  { label: 'פרויקטים', target: 'projects' },
  { label: 'לפני ואחרי', target: 'transformations' },
  { label: 'עיתונות', target: 'press' },
];

export default function NavMenu({ onOpenLead }) {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen((v) => !v), []);

  const scrollTo = useCallback(
    (id) => {
      setOpen(false);
      // Small delay so overlay closes before scroll
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 350);
    },
    [],
  );

  const handleCta = useCallback(() => {
    setOpen(false);
    if (onOpenLead) setTimeout(onOpenLead, 350);
  }, [onOpenLead]);

  // Lock body scroll when open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  // Close on Escape
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape' && open) setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  return (
    <>
      {/* Hamburger button */}
      <button
        type="button"
        className={`${s.burger} ${open ? s.burgerOpen : ''}`}
        onClick={toggle}
        aria-label={open ? 'סגור תפריט' : 'פתח תפריט'}
        aria-expanded={open}
      >
        <span className={s.burgerLines}>
          <span className={s.burgerLine} />
          <span className={s.burgerLine} />
          <span className={s.burgerLine} />
        </span>
      </button>

      {/* Full-screen overlay */}
      <div
        className={`${s.overlay} ${open ? s.overlayOpen : ''}`}
        aria-hidden={!open}
      >
        {/* Corner marks */}
        <span className={s.corner} data-corner="tr" />
        <span className={s.corner} data-corner="tl" />
        <span className={s.corner} data-corner="br" />
        <span className={s.corner} data-corner="bl" />

        <div className={s.navContent}>
          <nav aria-label="תפריט ראשי">
            <ul className={s.navList}>
              {NAV_LINKS.map((link) => (
                <li key={link.target} className={s.navItem}>
                  <button
                    type="button"
                    className={s.navLink}
                    onClick={() => scrollTo(link.target)}
                    tabIndex={open ? 0 : -1}
                  >
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          <div className={s.divider} />

          <button
            type="button"
            className={s.cta}
            onClick={handleCta}
            tabIndex={open ? 0 : -1}
          >
            <span className={s.ctaText}>לשיחת היכרות לחצו כאן</span>
            <span className={s.ctaArrow} aria-hidden="true">←</span>
          </button>

          <div className={s.socials}>
            <a
              href="https://www.instagram.com/lirit.langer_arch/"
              target="_blank"
              rel="noopener noreferrer"
              className={s.social}
              aria-label="אינסטגרם"
              tabIndex={open ? 0 : -1}
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
                <rect x="3" y="3" width="18" height="18" rx="5" />
                <circle cx="12" cy="12" r="4" />
                <circle cx="17.5" cy="6.5" r="0.8" fill="currentColor" />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/langershkori/"
              target="_blank"
              rel="noopener noreferrer"
              className={s.social}
              aria-label="פייסבוק"
              tabIndex={open ? 0 : -1}
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M13 22v-8h3l.5-4H13V7.5c0-1.2.4-2 2-2h2V2.2C16.6 2.1 15.6 2 14.4 2 11.9 2 10 3.5 10 6.2V10H7v4h3v8h3z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
